/** Tillåtna bredder – proxyn skalar bara till de här stegen så cachen förblir liten. */
export const IMAGE_WIDTHS = [200, 400, 600, 800, 1200, 1600] as const;
export type ImageWidth = (typeof IMAGE_WIDTHS)[number];

/**
 * Bygger rätt bild-URL: externa länkar används direkt, annars via vår bildproxy.
 * Ange `width` för att få en nedskalad variant – mycket mindre att ladda ner.
 */
export function adImageSrc(path: string | null | undefined, width?: ImageWidth): string {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  const base = `/api/public/images/${path}`;
  return width ? `${base}?w=${width}` : base;
}

/** srcSet för responsiva bilder (1x/2x) via proxyn. */
export function adImageSrcSet(
  path: string | null | undefined,
  widths: readonly ImageWidth[],
): string | undefined {
  if (!path || /^https?:\/\//i.test(path)) return undefined;
  return widths.map((w) => `${adImageSrc(path, w)} ${w}w`).join(", ");
}
